import { render, staticRenderFns } from "./staff-management.vue?vue&type=template&id=07124fbd&"
import script from "./staff-management.vue?vue&type=script&lang=js&"
export * from "./staff-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports